// extracted by mini-css-extract-plugin
module.exports = {"page":"_1nmPiQ2K","processing":"HnK0rkWa","blinking":"_33o1QGzP"};